var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/user';
import http from 'app/services/http';
export const userReducer = (state = {
    items: [],
    typeItems: [],
    selectedItem: null,
    searchValue: '',
}, action) => {
    var _a;
    switch (action.type) {
        case 'USER_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { items: items });
        }
        case 'USER_SET_SELECTED_ITEM': {
            const { data } = action.payload;
            if (!data) {
                return Object.assign(Object.assign({}, state), { selectedItem: null });
            }
            const selectedItem = Object.assign(Object.assign({}, data), { transportGroups: [], transportGroupsId: [], geofenceGroups: [], reportAccess: null });
            if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === ((_a = state === null || state === void 0 ? void 0 : state.selectedItem) === null || _a === void 0 ? void 0 : _a.id)) {
                selectedItem.transportGroups = state.selectedItem.transportGroups;
                selectedItem.transportGroupsId = state.selectedItem.transportGroupsId;
                selectedItem.geofenceGroups = state.selectedItem.geofenceGroups;
                selectedItem.autocolons = state.selectedItem.autocolons;
                selectedItem.reportAccess = state.selectedItem.reportAccess;
            }
            return Object.assign(Object.assign({}, state), { selectedItem });
        }
        case 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { transportGroups: items }) });
        }
        case 'USER_SET_SELECTED_ITEM_TRANSPORT_GROUP_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { transportGroups: state.selectedItem.transportGroups.map((item) => {
                        if (item.id !== id) {
                            return item;
                        }
                        return Object.assign(Object.assign({}, item), { checked: !item.checked });
                    }) }) });
        }
        case 'USER_SET_SELECTED_ITEM_AUTOCOLONS_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { autocolons: items }) });
        }
        case 'USER_SET_SELECTED_ITEM_GEOFENCE_GROUPS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { 
                    // Защита от не-массива в ответе API: строка/объект из ответа
                    // роняет рендер (geofenceGroups.flatMap is not a function).
                    geofenceGroups: Array.isArray(items) ? items : [] }) });
        }
        case 'USER_SET_SELECTED_ITEM_REPORT_ACCESS': {
            const { reportAccess } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { reportAccess }) });
        }
        case 'USER_SET_SEARCH_VALUE': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { searchValue: value });
        }
        case 'USER_ADD_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { items: [...state.items, data], selectedItem: Object.assign(Object.assign({}, data), { transportGroups: [], geofenceGroups: [] }) });
        }
        case 'USER_UPDATE_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }
                    return Object.assign(Object.assign({}, state.selectedItem), data);
                }), selectedItem: Object.assign(Object.assign({}, state.selectedItem), data) });
        }
        case 'USER_DELETE_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.id !== id), selectedItem: null });
        }
        case 'USER_SET_TYPE_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { typeItems: items });
        }
        default:
            return state;
    }
};
export function userLoad() {
    return function userLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/user');
            return dispatch(actions.setItems(data));
        });
    };
}
export function userCreate(params) {
    return function userCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/user', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function userUpdate(id, params) {
    return function userUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/user/${id}`, params);
            return dispatch(actions.updateItem(data));
        });
    };
}
export function userUpdatePassword(id, params) {
    return function userUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/password`, params);
            return dispatch(actions.updateItem(data));
        });
    };
}
export function userDelete(id) {
    return function userDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/user/${id}`);
            if (data) {
                dispatch(actions.deleteItem(id));
                return dispatch(actions.addItem(data));
            }
            return dispatch(actions.deleteItem(id));
        });
    };
}
export function userUnblock(id) {
    return function userDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(actions.deleteItem(id));
            const { data } = yield http.put(`/user/${id}/unblock`);
            return dispatch(actions.addItem(data));
        });
    };
}
export function userTypeFormLoad(withMyself = false) {
    return function userTypeFormLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/user/role?mode=${withMyself ? 'create' : 'edit'}`);
            return dispatch(actions.setTypeItems(data));
        });
    };
}
export function userTransportGroupLoad(id) {
    return function userTransportGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/user/${id}/group`);
            return dispatch(actions.setSelectedItemTransportGroupItems(data));
        });
    };
}
export function userTransportGroupPush(id, value) {
    return function userTransportGroupPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/user/${id}/group/${value}`);
            return dispatch(actions.setSelectedItemTransportGroupItem(value));
        });
    };
}
export function userTransportGroupDelete(id, value) {
    return function userTransportGroupPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/user/${id}/group/${value}`);
            return dispatch(actions.setSelectedItemTransportGroupItem(value));
        });
    };
}
export function userTransportGroupListPush(id, list) {
    return function userTransportGroupPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/user/${id}/groups`, {
                list,
            });
            return list.map((value) => dispatch(actions.setSelectedItemTransportGroupItem(value)));
        });
    };
}
export function userTransportGroupListDelete(id, list) {
    return function userTransportGroupPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/user/${id}/groups`);
            return list.map((value) => dispatch(actions.setSelectedItemTransportGroupItem(value)));
        });
    };
}
export function userGeofenceLoad(id) {
    return function userGeofenceLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/user/${id}/geofence`);
            return dispatch(actions.setSelectedItemGeofenceGroups(data));
        });
    };
}
export function userGeofencePush(id, value) {
    return function userGeofencePushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/geofence/${value}`);
            return dispatch(actions.setSelectedItemGeofenceGroups(data));
        });
    };
}
export function userGeofenceDelete(id, value) {
    return function userGeofenceDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/user/${id}/geofence/${value}`);
            return dispatch(actions.setSelectedItemGeofenceGroups(data));
        });
    };
}
export function userGeofenceListPush(id, list) {
    return function userGeofenceListPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/geofences`, {
                list,
            });
            return dispatch(actions.setSelectedItemGeofenceGroups(data));
        });
    };
}
export function userGeofenceListDelete(id, list) {
    return function userGeofenceListDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = (list === null || list === void 0 ? void 0 : list.length) ? `?ids=${list.join(',')}` : '';
            const { data } = yield http.delete(`/user/${id}/geofences${query}`);
            return dispatch(actions.setSelectedItemGeofenceGroups(data));
        });
    };
}
export function userAutocolonPush(id, value) {
    return function userAutocolonPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/autocolon/${value}`);
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function userAutocolonDelete(id, value) {
    return function userAutocolonDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/user/${id}/autocolon/${value}`);
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function userAutocolonsPush(id, list) {
    return function userAutocolonsPushThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/autocolons`, {
                list,
            });
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function userAutocolonsListDelete(id, list) {
    return function userAutocolonsListDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/user/${id}/autocolons/delete`, {
                list,
            });
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function userAutocolonsDelete(id) {
    return function userAutocolonsDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.delete(`/user/${id}/autocolons`);
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function getUserAutocolons(id) {
    return function getUserAutocolonsThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/user/${id}/autocolons`);
            return dispatch(actions.setSelectedItemAutocolonsItems(data));
        });
    };
}
export function userReportAccessLoad(id) {
    return function userReportAccessLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/user/${id}/report-types`);
            return dispatch(actions.setSelectedItemReportAccess(data));
        });
    };
}
export function userReportAccessSave(id, list) {
    return function userReportAccessSaveThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/user/${id}/report-types`, { list });
            return dispatch(actions.setSelectedItemReportAccess(data));
        });
    };
}
export default userReducer;
